import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import AddressMarker from './marker';

function groupStudents(students) {
  const addresses = {};
  _.forEach(students, (s) => {
    _.forEach(s.addresses, (address) => {
      if (addresses[address.full_address]) {
        addresses[address.full_address].students.push(s);
      } else {
        addresses[address.full_address] = { // eslint-disable-line no-param-reassign
          students: [s],
          location: { lat: address.lat, lng: address.lng },
          id: address.id,
          fullAddress: address.full_address,
          schedule: address.schedule,
        };
      }
    });
  });
  return addresses;
}

function timeToSchedule(time) {
  switch (time) {
    case 'morning_start': return 'morning';
    case 'morning_end': return 'noon';
    case 'afternoon_start': return 'noon';
    default: return 'afternoon';
  }
}

function filteredAddresses(students, grades, date, times) {
  return _(groupStudents(students))
    .filter(address => _.some(address.students, s => _.includes(grades, _.isNil(s.kind) ? undefined : s.kind)))
    .filter(({ schedule }) => (
      _.some(times, time => !!_.get(schedule, [moment(date).locale('en').format('dddd').toLowerCase(), timeToSchedule(time)]))
    ))
    .value();
}


const AddressMarkers = ({ selectedId, onClick, stops, overlayView, planId,
                          students, grades, schools, stoppableAddresses, stopKinds,
                          date, times }) => (
                            <div>
                              {_.map(filteredAddresses(students, grades, date, times), address => (
                                <AddressMarker
                                  key={address.id}
                                  address={address}
                                  planId={planId}
                                  selected={selectedId === address.id}
                                  onClick={onClick}
                                  stops={stops}
                                  schools={schools}
                                  stoppableAddresses={stoppableAddresses}
                                  overlayView={overlayView}
                                  stopKinds={stopKinds}
                                />
                              ))}
                            </div>
);

AddressMarkers.defaultProps = {
  planId: null,
  selectedId: null,
  overlayView: null,
  grades: ['junior', 'senior', undefined],
  students: [],
  stops: [],
  schools: [],
  stoppableAddresses: [],
  stopKinds: null,
  date: moment(),
  times: ['morning_start', 'morning_end', 'afternoon_start', 'day_end']
};

AddressMarkers.propTypes = {
  planId: PropTypes.number,
  selectedId: PropTypes.number,
  onClick: PropTypes.func.isRequired,
  students: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    first_name: PropTypes.string.isRequired,
    last_name: PropTypes.string.isRequired,
    klass: PropTypes.string.isRequired,
    grade: PropTypes.string.isRequired,
    kind: PropTypes.string.isRequired,
    photo: PropTypes.string,
    display_name: PropTypes.string.isRequired,
    addresses: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      lat: PropTypes.number.isRequired,
      lng: PropTypes.number.isRequired,
      full_address: PropTypes.string.isRequired,
      schedule: PropTypes.shape({}).isRequired,
    })),
  })),
  stops: PropTypes.arrayOf(PropTypes.shape({
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
  })),
  stopKinds: PropTypes.arrayOf(PropTypes.string),
  stoppableAddresses: PropTypes.arrayOf(PropTypes.shape({
    stoppable_id: PropTypes.number.isRequired,
    stoppable_type: PropTypes.oneOf(['Stop', 'School']).isRequired,
    address_id: PropTypes.number.isRequired,
  })),
  schools: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
    region: PropTypes.string.isRequired,
    radius: PropTypes.number,
    polygon: PropTypes.shape({
      path: PropTypes.arrayOf(PropTypes.shape({})),
    }),
  })),
  overlayView: PropTypes.instanceOf(google.maps.OverlayView),
  grades: PropTypes.arrayOf(PropTypes.string),
  date: PropTypes.instanceOf(moment),
  times: PropTypes.arrayOf(PropTypes.string),
};

export default AddressMarkers;
